import React, { Component, PropTypes} from 'react'

import * as actions from "../actions";
import * as utils from "../../utils";

import FeedComment from "./feed-comment";
import FeedReplyMenu from "./feed-reply-menu";
import LikesCount from "./likes-count";
import LikePost from "./like-post";
import TimeSince from "../../common/components/time-since";
import UserAvatar from "../../avatars/components";
import UserProfileLink from "../../common/components/user-profile-link";

function CommentReplies(props) {
  const {onReplyClick, replies, postId} = props;
  const { objects, more, cursor } = replies;
  const reply_nodes = objects.map((reply, i) => {
    return (
      <CommentReply key={reply.id} reply={reply} onReplyClick={onReplyClick} ></CommentReply>
    );
  });
  return (
    <div className="comment-replies">
      { more &&
        <ShowMoreRepliesLink postId={postId} cursor={cursor} />
      }
      {reply_nodes}
    </div>
  );
}

CommentReplies.propTypes = {
  replies: PropTypes.object.isRequired,
  postId: PropTypes.number.isRequired,
  onReplyClick: PropTypes.func,
};


const CommentReply = React.createClass({
  render: function() {
    const {reply, onReplyClick } = this.props;
    const { id, first_name, last_name } = reply.creator;
    const canDeleteEventItem = utils.canDeleteEventItem(id);
    const showReplyButton = !utils.isAndroid() && reply.creator_id !== window.user_id && onReplyClick;
    return (
      <div className={`feed-post ${reply.post_type || ''}`}>
        <div className="post-head">
          <UserAvatar
            userId={id}
            firstName={first_name}
            lastName={last_name}
            size="small"
          />
          <UserProfileLink userId={id} firstName={first_name} lastName={last_name} />
          <TimeSince timestamp={reply.created} />
          <FeedComment
            comment={reply.comment}
            commentEdited={reply.comment_edited}
            mentions={reply.mentions}
          />
          { canDeleteEventItem &&
            <FeedReplyMenu
              userId={id}
              postId={reply.parent_id}
              replyId={reply.id}
              comment={reply.comment}
              mentions={reply.mentions}
            />
          }
        </div>
        <div className="post-actions">
          { reply.likes > 0 &&
            <LikesCount liked={reply.liked} likes={reply.likes} likedBy={reply.liked_by} />
          }
          { utils.canComment() &&
            <LikePost
              postId={reply.parent_id}
              replyId={reply.id}
              likes={reply.likes}
              liked={reply.liked}
            />
          }

          { showReplyButton &&
            <div className="reply-to-post" onClick={this.handleReplyToPostClick}>Reply</div>
          }
        </div>
      </div>
    )
  },
  handleDeleteClick: function() {
    const { id, parent_id } = this.props.reply;
    actions.deleteReply(id, parent_id);
  },

  handleReplyToPostClick(event){
    let {onReplyClick} = this.props;
    if(onReplyClick){
      onReplyClick(event, this.props.reply)
    }
  }
});

CommentReply.propTypes = {
  reply: PropTypes.object.isRequired,
  onReplyClick: PropTypes.func
};


const ShowMoreRepliesLink = React.createClass({
  render: function() {
    return (
      <a onClick={this.handleShowMoreClick} className="show-more-replies-link">
        Show More Replies
      </a>
    )
  },
  handleShowMoreClick: function() {
    actions.getReplies(this.props.postId, this.props.cursor);
  }
});

export default CommentReplies;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-replies.es6